import { AxiosHttpClient } from '../core/http/axios-http-client';
import { Validator } from '../features/validation/validator';
import {
  LoginRequestSchema,
  AuthResponseSchema,
  type LoginRequest,
  type AuthResponse,
} from '../features/validation/schemas';
import {
  InvalidCredentialsError,
  ApiClientError,
} from '../core/errors/api-errors';
import { HttpError } from '../core/errors/http-error';

const HTTP_STATUS = {
  UNAUTHORIZED: 401,
} as const;

export async function login(
  baseUrl: string,
  workspaceId: string,
  credentials: LoginRequest,
  timeout?: number,
): Promise<AuthResponse> {
  const validatedCredentials = Validator.validate(
    LoginRequestSchema,
    credentials,
  );

  const apiUrl = `${baseUrl}/api/v1/${workspaceId}`;
  const httpClient = new AxiosHttpClient(apiUrl, timeout);

  try {
    const response = await httpClient.request<AuthResponse>({
      method: 'POST',
      url: '/login',
      data: validatedCredentials,
    });

    return Validator.validate(AuthResponseSchema, response.data);
  } catch (error) {
    if (
      error instanceof HttpError &&
      error.statusCode === HTTP_STATUS.UNAUTHORIZED
    ) {
      throw new InvalidCredentialsError('Invalid email or password');
    }

    if (error instanceof HttpError) {
      throw new ApiClientError(error.message, error.statusCode);
    }

    throw error;
  }
}
